module.exports = __webpack_public_path__ + "static/media/south-western_iberian_text_01.1135f3cc.jpg";